module.exports = __webpack_public_path__ + "img/dth.2cf91cfa.svg";